<div class="press">
    <div class="container">
        <div class="row mt-3">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb fqg f18">
                    <li class="mr-3"><img src="/assets/images/icon-yurt.png" alt="home"></li>
                    <li class="breadcrumb-item"><a href="/index" class="mgl">ᠲᠡᠷᠢᠭᠦᠨ ᠨᠢᠭᠤᠷ</a></li>
                    <li aria-current="page" class="breadcrumb-item active"><span class="mgl"> ᠨᠠᠢ᠌ᠮᠠᠨ ᠮᠤᠵᠢ ᠣᠷᠣᠨ ᠤ ᠬᠡᠪᠯᠡᠯ ᠦᠨ ᠬᠣᠷᠢᠶ᠎ᠠ </span></li>
                </ol>
            </nav>
        </div>
        <div class="row justify-content-center"><span class="col lpat"></span>
            <h4 class="col mgl catName justify-content-center fgq">ᠨᠠᠢ᠌ᠮᠠᠨ ᠮᠤᠵᠢ ᠣᠷᠣᠨ ᠤ ᠬᠡᠪᠯᠡᠯ ᠦᠨ ᠬᠣᠷᠢᠶ᠎ᠠ</h4><span class="col lpat"></span></div>
        <div class="row">
            <div class="col-sm-6 col-md-6 col-lg-3 media mgl pl-0 mb-4" *ngFor="let bs of bashengList">
                <img alt="..." class="align-self-center img-thumbnail mb-3" src="{{mUrl + bs.basheng.TuPian.Paths[0] }}">
                <div class="media-body align-self-center">
                    <a (click)="Setdetails(bs)">
                        <!-- href="/bsDetails/" -->
                        <h5 class="m-0 mr-1 fgq f22">{{ bs.DisplayText }}</h5>
                        <p class="fhw ml-0 mr-0" [innerHTML]="removeHTML(bs.HtmlBodyPart.Html)"></p>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="mask" *ngIf="Open">
    <div class="bs_box mgl container">
        <button class="btn_close" (click)="Open = false">
            <svg  width="24" height="24" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
        </button>
        <div id="scrollX" class="bs_content scrollbar_s">
            <img alt="..." class="align-self-center img-thumbnail mb-3" src="{{mUrl + details.basheng.TuPian.Paths[0] }}">
            <h4 class="mr-1 fgq f24 p-info">{{ details.DisplayText }}</h4>
            <p class="fhw ml-0 mr-0 p-info f18" innerHTML="{{ details.HtmlBodyPart.Html }}"></p>
        </div>
    </div>
</div>